import {
  Button,
  CardReactions,
  Heading,
  MediaQueries,
  PostContent,
  SharePopup,
  TagTopic,
  ThemeProps,
} from '@hhgtech/hhg-components'
import styled from 'styled-components'

import { CardAuthorWrapper } from '../cardAuthorWrapper'
import { InputCommentBar } from '../inputCommentBar'

export const StyledPin = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: ${(props: ThemeProps) => props.theme.colors.yellow50};
  border-radius: 50%;
  margin-right: 16px;
`

export const StyledInnerPadding = styled.div`
  padding: 16px 0;
`

export const StyledCardAuthorWrapper = styled(CardAuthorWrapper)`
  margin-bottom: 16px;
`

export const StyledCardReactions = styled(CardReactions)``

export const StyledHeading = styled(Heading)`
  margin-bottom: 16px;
`

export const StyledSocialPreview = styled.div`
  margin-top: 16px;

  &:empty {
    margin-top: 0;
  }
`
export const StyledTagTopic = styled(TagTopic)`
  .tag-link-item {
    border: 0;
    background: ${(props: ThemeProps) => props.theme.colors.neutral50};
  }
`
export const StyledTagList = styled.div`
  padding: 0 0 0 16px;
`
export const StyledPostContent = styled(PostContent)`
  padding: 0;
`
export const StyledCardReplyWrapper = styled.div`
  padding: 0 0 16px 0;

  &:hover {
    cursor: pointer;
  }
`
export const StyledMoreLink = styled(Button)``
export const StyledInputCommentBar = styled(InputCommentBar)`
  margin-top: 16px;
`

export const StyledCardPost = styled.div`
  &.flat-top {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .post-pin {
    padding: 0.5rem 1rem;
    border-radius: 6px 6px 0 0;
  }

  .post-content-title {
    margin-bottom: 16px;
  }
  .post-content-link-wrapper {
    color: inherit;
  }

  .post-topics {
    padding: 0;
  }
  .most-engaging-wrapper {
    padding: 0 16px;
    cursor: pointer;
    .author-avatar-wrapper {
      width: 2rem;
      height: 2rem;
      font-size: 1rem;
    }
    .see-more-comments {
      width: 100%;
      padding: 0 1rem 1rem;
      text-align: unset;
    }
  }
  &[data-most-engaging='true'] {
    border: none;
    ${MediaQueries.mbDown} {
      margin: 1rem;
      border: 1px solid #e4e8ec;
    }
  }
  .top-divider {
    border-color: #e4e8ec;
  }

  .image-preview-wrapper {
    &[data-sensitive='true'] {
      & > div:first-child {
        margin-left: 16px;
        margin-right: 16px;
      }
    }
  }
`
export const StyledWrapper = styled.div`
  background: white;
  border-radius: inherit;
`
// export const StyledCardReply = styled(CardReply)``
export const StyledPostContentWrapper = styled.div`
  position: relative;
`
export const StyledPostContentLinkWrapper = styled.div``
export const StyledLinkOverlay = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`
export const StyledSharePopup = styled(SharePopup)``
